import { render } from "./wfm-radio-button.vue?vue&type=template&id=217c5fe3"
import script from "./wfm-radio-button.vue?vue&type=script&lang=js"
export * from "./wfm-radio-button.vue?vue&type=script&lang=js"

import "./wfm-radio-button.vue?vue&type=style&index=0&id=217c5fe3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__